import React from "react";
import "./Footer.css";
import brgegwhite from "../../assets/brgegwhite.webp";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaTikTok,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info Section */}
        <div className="footer-section company-info">
          <img
            src={brgegwhite}
            alt="BinRashid Group Egypt Logo"
            className="footer-logo"
          />
          <p>
            BinRashid Group Egypt - Providing 360° business solutions to help
            you start, grow, and succeed.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section quick-link">
          <h4>Quick Links</h4>

          <a href="/contact-us">
            <p>Contact Us</p>
          </a>
          <a href="/business-solutions">
            <p> Business Solutions</p>
          </a>
          <a href="/consulting">
            <p>Consulting</p>
          </a>
          <a href="/construction-interior">
            <p>Construction & Interior</p>
          </a>
        </div>

        {/* Contact Info Section */}
        <div className="footer-section contact-info">
          <h4>Contact Us</h4>
          <p>
            <strong>Address:</strong> Lasirena building, Ring Rd, El Katameya,
            Level 1.
          </p>
          <p>
            <strong>Phone:</strong>
          </p>
          <div className="flag-icon">
            <span></span> +20 12 1222 0604
          </div>
          <div className="flag-icon">
            <span></span> +20 12 1222 0605
          </div>

          <p>
            <strong>Email:</strong> info@binrashideg.com
          </p>

          <div className="social-links">
            <a
              href="https://www.facebook.com/share/14G7ugZXSEj/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.linkedin.com/company/binrashid-egypt/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/binrashid_marketing?igsh=bDduY3JiOGJ1aG41 "
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@bin.rashid.egypt?_t=ZS-8xqxWLQNsMS&_r=1 "
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <SiTiktok />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© 2025 BinRashid Group Egypt. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
